import { HttpClient } from '@/shared/lib/http-client';

export const fetchModelsByMake = async (vehicleMake) => {
  const response = await HttpClient.get(`/directories/car/models/${vehicleMake}`);

  return response.data;
};
